import React from 'react';
import classNames from 'classnames';
import styles from './tabs.module.css.js';

function Tab({ id, selected = false, onClick, children, disabled = false }) {
    return (React.createElement("button", { id: id, type: 'button', role: 'tab', onClick: onClick, className: classNames(styles.tab, { [styles.selectedTab]: !disabled && selected }), "aria-controls": `${id}-tabpanel`, "aria-selected": selected, disabled: disabled }, children));
}

export { Tab as default };
